document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-menu-toggle]');
  if (trigger) document.body.classList.toggle('menu-open');
});

function formatMoney(cents, currencyCode) {
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency',
      currency: currencyCode || 'GBP'
    }).format(Number(cents) / 100);
  } catch (error) {
    return `£${(Number(cents) / 100).toFixed(2)}`;
  }
}

function initProduct(root) {
  const slides = [...root.querySelectorAll('[data-media-id].product-gallery-slide')];
  const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
  const currentCounter = root.querySelector('[data-gallery-current]');
  const select = root.querySelector('[data-variant-select]');
  const priceBox = root.querySelector('[data-product-price]');
  const stockBox = root.querySelector('[data-product-stock]');
  const addButton = root.querySelector('[data-add-to-cart]');
  const quantityInput = root.querySelector('[data-quantity-input]');
  const currency = window.Shopify?.currency?.active || 'GBP';
  let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

  const showMedia = (indexOrId) => {
    if (!slides.length) return;
    let nextIndex = typeof indexOrId === 'number'
      ? indexOrId
      : slides.findIndex((slide) => String(slide.dataset.mediaId) === String(indexOrId));
    if (nextIndex < 0) nextIndex = 0;
    activeIndex = (nextIndex + slides.length) % slides.length;
    slides.forEach((slide, index) => slide.classList.toggle('is-active', index === activeIndex));
    thumbs.forEach((thumb, index) => thumb.classList.toggle('is-active', index === activeIndex));
    if (currentCounter) currentCounter.textContent = String(activeIndex + 1);
    thumbs[activeIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  };

  thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(Number(thumb.dataset.mediaIndex))));
  root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showMedia(activeIndex - 1));
  root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showMedia(activeIndex + 1));

  let touchStartX = 0;
  const mediaFrame = root.querySelector('.product-main-media--gallery');
  mediaFrame?.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
  mediaFrame?.addEventListener('touchend', (event) => {
    const delta = event.changedTouches[0].clientX - touchStartX;
    if (Math.abs(delta) > 45) showMedia(activeIndex + (delta < 0 ? 1 : -1));
  }, { passive: true });

  const updateVariant = () => {
    if (!select || select.tagName !== 'SELECT') return;
    const option = select.options[select.selectedIndex];
    const available = option.dataset.available === 'true';
    const price = Number(option.dataset.price || 0);
    const comparePrice = Number(option.dataset.comparePrice || 0);
    const mediaId = option.dataset.mediaId;

    if (priceBox) {
      let markup = `<strong>${formatMoney(price, currency)}</strong>`;
      if (comparePrice > price) {
        const saving = Math.round(((comparePrice - price) / comparePrice) * 100);
        markup += ` <span class="compare">${formatMoney(comparePrice, currency)}</span> <span class="sale-badge sale-badge--inline">SAVE ${saving}%</span>`;
      }
      priceBox.innerHTML = markup;
    }

    if (stockBox) {
      stockBox.textContent = available ? '● In stock' : '● Sold out';
      stockBox.classList.toggle('is-sold-out', !available);
    }
    if (addButton) {
      addButton.disabled = !available;
      addButton.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
    }
    if (mediaId) showMedia(mediaId);

    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  };

  select?.addEventListener('change', updateVariant);
  root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
    if (quantityInput) quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
  });
  root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
    if (quantityInput) quantityInput.value = Number(quantityInput.value || 1) + 1;
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-root]').forEach(initProduct);
});

function initPredictiveSearch() {
  const drawer = document.querySelector('[data-search-drawer]');
  const input = document.querySelector('[data-predictive-search-input]');
  const results = document.querySelector('[data-predictive-results]');
  let timer;
  const close = () => { if (drawer) drawer.hidden = true; document.body.classList.remove('search-open'); };
  document.querySelector('[data-search-open]')?.addEventListener('click', () => { drawer.hidden = false; document.body.classList.add('search-open'); setTimeout(() => input?.focus(), 50); });
  document.querySelector('[data-search-close]')?.addEventListener('click', close);
  drawer?.addEventListener('click', (e) => { if (e.target === drawer) close(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  input?.addEventListener('input', () => {
    clearTimeout(timer);
    const q = input.value.trim();
    if (q.length < 2) { results.innerHTML = ''; return; }
    results.innerHTML = '<div class="search-loading">Searching…</div>';
    timer = setTimeout(async () => {
      try {
        const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
        const data = await response.json();
        const products = data.resources?.results?.products || [];
        results.innerHTML = products.length ? products.map((product) => `
          <a class="predictive-item" href="${product.url}">
            ${product.image ? `<img src="${product.image}" alt="">` : '<span class="predictive-placeholder"></span>'}
            <span><b>${product.title}</b><small>${product.price}</small></span>
          </a>`).join('') : '<div class="search-empty">No products found.</div>';
      } catch (error) { results.innerHTML = '<div class="search-empty">Search is unavailable right now.</div>'; }
    }, 180);
  });
}

document.addEventListener('DOMContentLoaded', initPredictiveSearch);

function initAjaxCart() {
  const form = document.querySelector('[data-cart-form]');
  if (!form) return;
  const total = form.querySelector('[data-cart-total]');
  const status = form.querySelector('[data-cart-status]');
  const currency = window.Shopify?.currency?.active || 'GBP';
  let pending;

  async function changeLine(line, quantity, row) {
    clearTimeout(pending);
    if (status) status.textContent = 'Updating…';
    row?.classList.add('is-updating');
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      if (!response.ok) throw new Error('Cart update failed');
      const cart = await response.json();
      if (quantity === 0) {
        row?.remove();
      } else {
        const item = cart.items[line - 1];
        if (item && row) row.querySelector('[data-line-price]').textContent = formatMoney(item.final_line_price, currency);
      }
      if (total) total.textContent = formatMoney(cart.total_price, currency);
      if (status) status.textContent = 'Cart updated';
      document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
      if (cart.item_count === 0) window.location.reload();
      pending = setTimeout(() => { if (status) status.textContent = ''; }, 1400);
    } catch (error) {
      if (status) status.textContent = 'Could not update. Please try again.';
      window.setTimeout(() => window.location.reload(), 900);
    } finally {
      row?.classList.remove('is-updating');
    }
  }

  form.querySelectorAll('[data-cart-line]').forEach((row) => {
    const line = Number(row.dataset.cartLine);
    const input = row.querySelector('[data-cart-quantity]');
    row.querySelector('[data-cart-minus]')?.addEventListener('click', () => {
      input.value = Math.max(0, Number(input.value || 0) - 1);
      changeLine(line, Number(input.value), row);
    });
    row.querySelector('[data-cart-plus]')?.addEventListener('click', () => {
      input.value = Number(input.value || 0) + 1;
      changeLine(line, Number(input.value), row);
    });
    input?.addEventListener('change', () => {
      input.value = Math.max(0, Number(input.value || 0));
      changeLine(line, Number(input.value), row);
    });
  });
}

document.addEventListener('DOMContentLoaded', initAjaxCart);

function initCollectionSort() {
  document.querySelectorAll('[data-collection-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      document.documentElement.classList.add('is-page-loading');
      window.location.assign(url.toString());
    });
  });
}

document.addEventListener('DOMContentLoaded', initCollectionSort);

function initProductRecommendations() {
  document.querySelectorAll('[data-product-recommendations]').forEach(async (section) => {
    const url = section.dataset.url;
    if (!url) return;
    section.classList.add('is-loading');
    try {
      const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Recommendations unavailable');
      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const replacement = documentFragment.querySelector('[data-product-recommendations]');
      if (replacement && replacement.innerHTML.trim()) {
        section.innerHTML = replacement.innerHTML;
        requestAnimationFrame(() => section.classList.add('is-ready'));
      } else {
        section.remove();
      }
    } catch (error) {
      section.remove();
    } finally {
      section.classList.remove('is-loading');
    }
  });
}

document.addEventListener('DOMContentLoaded', initProductRecommendations);
